<template>
  <router-view></router-view>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { debounce } from "lodash";
export default defineComponent({
  setup() {
    const _ = (window as any).ResizeObserver;
    (window as any).ResizeObserver = class ResizeObserver extends _ {
      constructor(callback: (...args: any[]) => void) {
        callback = debounce(callback, 100);
        super(callback);
      }
    };
  },
  components: {},
});
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
html,
body,
#app {
  height: 100%;
  margin: 0;
  padding: 0;
}

.el-drawer__footer {
  border: 1px solid #f0f1e9;
}
.el-drawer__body {
  padding: 0 !important;
}
.el-divider--horizontal {
  margin: 0px 0px !important;
}

.el-drawer__header {
  margin-bottom: 22px !important;
}
.el-tree {
  --el-tree-node-content-height: 35px !important;
}
.el-drawer__title {
  font-size: 20px;
  color: black;
}

/*设置用户角色复选框是否显示*/
.user-role-style > .el-tree-node__content > .el-checkbox .is-disabled {
  display: none;
}

/*设置按钮权限复选框是否显示*/
.role-button-style > .el-tree-node__content > .el-checkbox {
  display: none;
}
/*
设置用户角色字体颜色
*/
.user-role-style > .el-tree-node__content {
  color: #909399;
}

/*
设置下级角色菜单字体颜色
*/
.subordinate-role-menu > .el-tree-node__content {
  color: #909399;
}

/* 针对WebKit浏览器 */
::-webkit-scrollbar {
  width: 6px; /* 滚动条宽度 */
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background: #f1f1f1; /* 轨道颜色 */
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: #888; /* 滑块颜色 */
  border-radius: 10px; /* 滑块圆角 */
}

/* 当鼠标悬停在滑块上时 */
::-webkit-scrollbar-thumb:hover {
  background: #555; /* 滑块悬停颜色 */
}

/*行-导航样式*/
.rowNavStyle {
  border: 1px solid #00152914;
  box-shadow: 0 1px 4px #00152914;
  margin-bottom: 10px;
  /* margin-left: 10px;
  margin-right: 10px; */
  /* border-radius: 10px; */
}
/*列-导航样式*/
.colNavStyle {
  height: 50px;
  display: flex !important;
  justify-content: left;
  align-items: center;
  /* padding-left: 5px; */
  flex-flow: row wrap;
}

.table-style {
  border-radius: 12px;
  /* overflow: hidden;
  border: 1px solid #e4e7ed; */
  margin-left: 10px;
  margin-right: 10px;
}

.el-table__body-wrapper {
  font-size: 14px;
}

/* 确保表格填满容器 */
.table-style :deep(.el-table) {
  border: none;
}

/* 上分割线 */
.custom-divider-top {
  width: calc(100% + 32px);
  margin-left: -16px;
  margin-top: 0px;
  margin-bottom: 10px;
  border-color: #d3d1d1;
  height: 1px;
  background-color: #d3d1d1;
}

/* 下分割线 */
.custom-divider-bottom {
  width: calc(100% + 32px);
  margin-left: -16px;
  margin-top: 0px;
  margin-bottom: 10px;
  border-color: #d3d1d1;
  height: 1px;
  background-color: #d3d1d1;
}
.el-dialog__header {
  text-align: left;
}

/* tip提示样式 */
.el-popper.is-customized {
  /* Set padding to ensure the height is 32px */
  padding: 6px 12px;
  background: linear-gradient(90deg, rgb(159, 229, 151), rgb(204, 229, 129));
}
/* tip提示样式 */
.el-popper.is-customized .el-popper__arrow::before {
  background: linear-gradient(45deg, #b2e68d, #bce689);
  right: 0;
}

/* 下拉框按钮样式 */
.dropdown-menu-class {
  display: grid;
}
.dropdown-menu-class > * {
  margin: 5px;
}
</style>

function debounce(callback: (...args: any[]) => void, arg1: number): (...args: any[]) =>
void { throw new Error("Function not implemented."); }
